import { getRetrieveCurrentAssessmentQueryKey } from "@/core/api/orval/ageless-assessments/ageless-assessments";

import { getAssessmentIdFromBearerToken } from "./assessmentToken";

/**
 * Query key for the current-assessment cache, scoped by the assessment id
 * carried in the bearer token. The response of `/assessments/current` is
 * determined by the token's `ageless_assessment_id` claim, so the claim must
 * be part of the cache identity — otherwise a token swap (reauthenticate,
 * expired-token re-define, url-token arrival) keeps serving the previous
 * assessment from cache.
 *
 * Every read/write of this cache MUST go through this helper:
 * `setQueryData`/`getQueryData` match keys exactly, so a call site using the
 * unscoped orval key silently targets an entry no query observes.
 */
export function getScopedCurrentAssessmentQueryKey(authorizationHeader: string) {
  return [
    ...getRetrieveCurrentAssessmentQueryKey(),
    getAssessmentIdFromBearerToken(authorizationHeader) ?? "anonymous",
  ] as const;
}
